<template>
    <div class="row">
        <div class="col-12 header" >
            <header-component
                :personalPage="personalPage"
                :secondProgress="secondProgress"
                v-on:searchFieldValue="(val) => setSearchFieldValue(val)"
                v-on:searchFieldData="(val) => setsearchFieldData(val)"
            />
        </div>
        <div class="col-12 main-container" >
            <first-step-booking-component
                v-if="personalPage == false"
                v-on:personalPage="(val) => setPersonalPage(val)"
                v-on:data="(val) => setData(val)"
                :searchFieldValue="this.searchFieldValue"
                v-on:roomOffer="(val) => setRoomOffer(val)"
                v-on:roomTheme="(val) => setRoomTheme(val)"
                v-on:secondProgress="(val) => setSecondProgress(val)"
            />

            <second-step-booking-component
                v-if="personalPage == true"
                v-on:personalPage="(val) => setPersonalPage(val)"
                :data="data" :roomOffer="roomOffer"
                :roomTheme="roomTheme"
                v-on:secondProgress="(val) => setSecondProgress(val)"
                :payment_profile_id="this.payment_profile_id"
                :payment_access_key="this.payment_access_key"
                :payment_url="this.payment_url"
                :transaction_uuid="transaction_uuid"
                :session_id="session_id"
                :signed_date_time="signed_date_time"
            />

            <br><br><br>
            <br><br><br>

        </div>
    </div>
</template>

<script>
    import HeaderComponent from "./header/HeaderComponent";
    import FirstStepBookingComponent from "./body/FirstStepBookingComponent";
    import SecondStepBookingComponent from "./body/SecondStepBookingComponent";
    export default {
        name: "Booking",
        components: {SecondStepBookingComponent, FirstStepBookingComponent, HeaderComponent},
        props: [
            'transaction_uuid',
            'signed_date_time',
            'session_id',
            'payment_profile_id',
            'payment_access_key',
            'payment_url'
        ],
        data () {
            return {
                personalPage:false,
                searchResult:[],
                searchFieldData:[],
                data:[],
                roomOffer:[],
                roomTheme:[],
                searchFieldValue:[],
                secondProgress:false
            }
        },
        methods : {
            setPersonalPage : function (value) {
              this.personalPage = value;
            }
            ,setSearchFieldValue :function (value) {
                this.searchFieldValue = value;
                // console.log(value)
            }
            ,setsearchFieldData :function (value) {
                this.searchFieldData = value;
                // console.log(value)
            }
            ,setData :function (value) {
                this.data = value;
                // console.log(value)
            }
            ,setRoomOffer :function (value) {
                this.roomOffer = value;
            }
            ,setRoomTheme :function (value) {
                this.roomTheme = value;
            },
            setSecondProgress: function (value) {
                this.secondProgress = value;
            },
        },
        watch : {
            personalPage : function (newVal,endVal) {
            },
            searchResult : function (newVal,endVal) {
            }
        }
    }
</script>

<style scoped>
    .header{
        padding: 10px;
    }
    .main-container{
        margin-top: 10px;
    }
</style>
